import { render, staticRenderFns } from "./AddAdminUser.vue?vue&type=template&id=dc8a386a&scoped=true"
import script from "./AddAdminUser.vue?vue&type=script&lang=js"
export * from "./AddAdminUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8a386a",
  null
  
)

export default component.exports